import xlsx, { ISettings, IJsonSheet, IContent } from 'json-as-xlsx';
import moment  from 'moment';
import { EmailItemResponse, ListarFiltroEmailQuery } from 'core/features/relatorios/typings';
import { StatusEmail } from 'features/relatorios/typings';

export function exportExcelRelatorioEmail({
  emails,
  filtro,
}: {
  emails: EmailItemResponse[];
  filtro: ListarFiltroEmailQuery
}) {
  const settings: ISettings = { 
    fileName: `Relatório de Emails - ${moment(filtro.dataInicio).format('DD_MM_YYYY')} a ${moment(filtro.dataFim).format('DD_MM_YYYY')}`,
    extraLength: 3,
    writeOptions: {},
  }

  const isEnviado = (row: IContent) => {
    return (row.data && row.status !== StatusEmail.Error) ||
    row.dataEntregue
  };

  const columns = [
    {
      label: 'Pessoa', value: 'nome',
    },
    {
      label: 'Email', value: 'email',
    },
    {
      label: 'Mensagem', value: 'assunto',
    },
    {
      label: 'Data de Envio', value: (row: IContent) => {
        const _isEnviado = isEnviado(row);;
        
        return _isEnviado
        ? moment(row.data as string || row.dataEntregue as string).format(
            "DD/MM/YYYY [ás] HH:mm"
          )
        : "Não enviado";
    },
  },
    {
      label: 'Data de Entrega', value: (row: IContent) => {       
        return row.dataEntregue
        ? moment(row.dataEntregue as string).format(
            "DD/MM/YYYY [ás] HH:mm"
          )
        : "Não entregue";
    },
    },
    {
      label: 'Lido em', value: (row: IContent) => {
        return row.data && row.dataVisualizacao
        ? `Lido em ${moment(row.dataVisualizacao as string).format(
            "DD/MM/YYYY [ás] HH:mm"
          )}` : !row.data ? '--' : "Não Lido"
      },
    },
  ];

  const contentMapper = (item: EmailItemResponse) => {
    const obj: Record<keyof EmailItemResponse, any> = {} as any;

    Object.keys(item).forEach((key) => {
      obj[key as keyof EmailItemResponse] = item[key as keyof EmailItemResponse] ?? '';
    })

    return obj;
  }


  const data: IJsonSheet[] = [
    {
      sheet: 'Emails',
      columns: columns,
      content: emails.map(contentMapper),
    },
  ]

  xlsx(data, settings);
}